import { useTranslation } from "react-i18next";
import { Grid, TextField, Typography } from "@mui/material";
import { DesktopDatePicker } from "@mui/x-date-pickers";
import { format } from "date-fns";
import {
  Controller,
  FieldArrayWithId,
  UseFieldArrayUpdate,
  useFormContext,
} from "react-hook-form";

import { isoFormat } from "../../../common/helpers/formatDateTime";
import { PricingTable } from "./PricingTable";
import { RoundedButton } from "../../../common/components/styled/styled";
import { PricingFormValues } from "./SupplementPricing";

type Props = {
  fields: FieldArrayWithId<PricingFormValues, "prices", "id">[];
  saveDisabled: boolean;
  saveChanges: () => void;
  update: UseFieldArrayUpdate<PricingFormValues, "prices">;
};

export const PricingFormContainer = ({
  fields,
  saveDisabled,
  saveChanges,
  update,
}: Props) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  let minusTwoWeeks = new Date();
  minusTwoWeeks.setDate(minusTwoWeeks.getDate() - 14);

  return (
    <>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("talentProfile:validFrom")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <Controller
          name="validFrom"
          control={control}
          render={({ field }) => (
            <DesktopDatePicker
              {...field}
              value={new Date(field.value)}
              onChange={(value: Date | null) => {
                field.onChange(value ? format(value, isoFormat) : "");
              }}
              minDate={minusTwoWeeks}
              format="dd.MM.yyyy"
              slots={{ textField: TextField }}
              slotProps={{
                textField: {
                  size: "small",
                },
              }}
            />
          )}
        />
      </Grid>
      <Grid item container xs={3} justifyContent="flex-end" alignItems="center">
        <Typography textAlign="end" variant="secondary">
          {t("settings:pricing")}
        </Typography>
      </Grid>
      <Grid item xs={9}>
        <PricingTable fields={fields} update={update} />
      </Grid>
      <Grid item xs={3} />
      <Grid item xs={9}>
        <RoundedButton
          variant="contained"
          disabled={saveDisabled}
          onClick={saveChanges}
        >
          {t("save")}
        </RoundedButton>
      </Grid>
    </>
  );
};
